import { render } from "./FamilyInfoStepComponent.vue?vue&type=template&id=a3188d6a&ts=true"
import script from "./FamilyInfoStepComponent?vue&type=script&lang=ts"
export * from "./FamilyInfoStepComponent?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/atlantis/atlantis/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__